import Vue from "vue"
import Vuex from "vuex"
import state from "./global/state.js"
import mutations from "./global/mutations.js"
import actions from "./global/actions.js"

import auth from "@/modules/auth/store/index.js"
import clients from "@/modules/clients/store/index.js"
import policies from "@/modules/policies/store/index.js"
import quotes from "@/modules/quotes/store/index.js"
import reports from "@/modules/reports/store/index.js"
import caseManagement from "@/modules/caseManagement/store/index.js"
import templates from "@/modules/templates/store/index.js"
import transactions from "@/modules/transactions/store"
import objects from "@/modules/objects/store/index.js"
import education from "@/modules/education/store/index.js"
import resources from "@/modules/resources/store/index.js"

Vue.use(Vuex)

export default new Vuex.Store({
	strict: true,
	state,
	mutations,
	actions,
	modules: {
		auth: {
			namespaced: true,
			...auth
		},
		clients: {
			namespaced: true,
			...clients
		},
		policies: {
			namespaced: true,
			...policies
		},
		quotes: {
			namespaced: true,
			...quotes
		},
		reports: {
			namespaced: true,
			...reports
		},
		caseManagement: {
			namespaced: true,
			...caseManagement
		},
		templates: {
			namespaced: true,
			...templates
		},
		transactions: {
			namespaced: true,
			...transactions
		},
		objects: {
			namespaced: true,
			...objects
		},
		education: {
			namespaced: true,
			...education
		},
		resources: {
			namespaced: true,
			...resources
		}
	}
})
